import { render, staticRenderFns } from "./BAutocompletePublication.vue?vue&type=template&id=3f49591e&"
import script from "./BAutocompletePublication.vue?vue&type=script&lang=js&"
export * from "./BAutocompletePublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports